import React, { Component } from 'react';
import { Button, Checkbox, Grid } from '@material-ui/core';
import _ from 'lodash';
import { connect } from 'react-redux';
// import MyPATCalendar from 'react-MyPATCalendar';
import { contentManagementAction } from '../../reducers/contentMangementData';
import { addNewMilestone } from '../treeComponents/helper/addNewMilestone';
import { bindActionCreators } from 'redux';
import MyPATTextField from '../../../common/MyPATTextField';
import { WithStyles, withStyles } from '@material-ui/core';
import { editMilestoneStyle } from '../../styles';
import MyPATCalendar from '../../../common/MyPATCalendar';
import {
  appendNewMilestone,
  getMaxDateForStart,
  getMinDateForEnd,
  getEndDateOfLastWeek,
  getMinDate,
  getMaxDate,
  getNextPhaseStartDate,
} from '../treeComponents/helper';

interface AddCourseMileStoneProps extends WithStyles<typeof editMilestoneStyle> {
  treeData: any;
  parentNode: any;
  setTreeData: any;
  classes: any;
  closeHoverBar: Function;
  atBottom: boolean;
}

interface AddCourseMileStoneState {
  isOpen: boolean;
  milestoneName: string;
  milestoneStartDate: Date;
  milestoneEndDate: Date;
  isRevision: boolean;
  nameError: string;
  minDate: Date;
  maxDate: Date;
}

class AddCourseMileStone extends Component<AddCourseMileStoneProps, AddCourseMileStoneState> {
  constructor(props: AddCourseMileStoneProps) {
    super(props);
    this.state = {
      isOpen: true,
      milestoneName: '',
      milestoneStartDate: this.getDefaultMinDate(),
      milestoneEndDate: this.getDefaultMaxDate(),
      isRevision: false,
      nameError: '',
      minDate: this.getDefaultMinDate(),
      maxDate: this.getDefaultMaxDate(),
    };
  }

  isDateRangeValid = () => {
    const minDate = this.state.milestoneStartDate;
    const maxDate = this.state.milestoneEndDate;

    if (new Date(minDate).getTime() >= new Date(maxDate).getTime()) {
      return false;
    }
    return true;
  };

  getDefaultMinDate = () => {
    const { treeData, parentNode } = this.props;
    const { phaseIndex } = parentNode;

    // if parent is last phase
    if (parentNode.key === 'phase' && this.props.atBottom) {
      const date = new Date(parentNode.endDate);
      return new Date(date.setDate(date.getDate() + 1));
    }
    // if parent not last phase
    if (parentNode.key === 'phase' && phaseIndex > 0) {
      const { phases = [] } = treeData;
      const index = phaseIndex - 1;
      const preceedingPhase = phases[index];
      const date = new Date(preceedingPhase.endDate);
      return new Date(date.setDate(date.getDate() + 1));
    }

    // if parentNode is a week
    return new Date(parentNode.startDate);
  };

  getDefaultMaxDate = () => {
    const { treeData, parentNode } = this.props;
    const { phaseIndex } = parentNode;
    //if parentNode is a week
    if (parentNode.key === 'week') {
      // const { phases = [] } = treeData;
      // const succeedingPhase = phases[phaseIndex + 1];
      // return succeedingPhase ? succeedingPhase.startDate : treeData.endDate;
      return getEndDateOfLastWeek(parentNode, treeData);
    }
    // if parent is last phase
    if (parentNode.key === 'phase' && this.props.atBottom) {
      const { endDate } = treeData;
      return new Date(endDate);
    }
    //if parentNode is not last phase
    const startDate = new Date(parentNode.startDate);
    return new Date(startDate.setDate(startDate.getDate() - 1));
  };

  handleCancel = () => {
    this.setState((prevState: AddCourseMileStoneState) => ({
      ...prevState,
      isOpen: false,
      milestoneName: '',
      milestoneStartDate: '',
      milestoneEndDate: '',
      isRevision: false,
      nameError: '',
    }));
    this.props.closeHoverBar();
  };

  handleName = (e: any) => {
    this.setState({
      milestoneName: e.target.value,
    });
  };

  handleStartDate = (date: Date | null) => {
    if (date)
      this.setState({
        milestoneStartDate: date,
      });
  };

  handleEndDate = (date: Date | null) => {
    if (date)
      this.setState({
        milestoneEndDate: date,
      });
  };

  handleIsRevision = (e: any, minDate: Date | string, maxDate: Date | string) => {
    this.setState(
      {
        isRevision: !this.state.isRevision,
      },
      () => {
        if (!this.state.isRevision) {
          this.setState({
            milestoneStartDate: getMinDate(minDate),
            milestoneEndDate: getMaxDate(maxDate),
          });
        }
      }
    );
  };

  handleSave = () => {
    if (this.state.milestoneName.trim()) {
      const newMileStone = {
        name: this.state.milestoneName.trim(),
        endDate: this.state.milestoneEndDate,
        startDate: this.state.milestoneStartDate,
        isRevision: this.state.isRevision,
      };
      if (this.props.atBottom) {

        appendNewMilestone(this.props.treeData, this.props.setTreeData, newMileStone);
      } else {
        
        addNewMilestone(this.props.treeData, this.props.setTreeData, this.props.parentNode, newMileStone);
      }

      this.setState({
        isOpen: false,
        nameError: '',
      });
      this.props.closeHoverBar();
    } else {
      this.setState({ nameError: 'Name is required' });
    }
  };

  render() {
    const { classes, parentNode, treeData } = this.props;
    const { milestoneName, nameError, milestoneEndDate, milestoneStartDate, minDate, maxDate } = this.state;
    return (
      <>
        {this.state.isOpen ? (
          <div aria-labelledby='customized-dialog-title'>
            <Grid
              container
              justify='space-between'
              alignItems='center'
              className={[classes.mt10, classes.addEditMilestone].join(' ')}
            >
              <Grid item>
                <Grid container spacing={8}>
                  <Grid item>
                    <MyPATTextField
                      fullWidthControl
                      onChange={this.handleName}
                      id='outlined-uncontrolled'
                      fullWidth
                      name='phase'
                      margin='normal'
                      variant='outlined'
                      value={milestoneName}
                      placeholder='Milestone Name'
                      required={true}
                      error={nameError}
                      helperText={nameError}
                    />
                  </Grid>
                  <Grid item className={classes.MyPATCalendarUi}>
                    <MyPATCalendar
                      onChange={this.handleStartDate}
                      date={milestoneStartDate}
                      // minDate={this.getMinDate(minDate)}
                      // maxDate={this.getMaxDate(maxDate)}
                      minDate={minDate}
                      maxDate={getMaxDateForStart(milestoneEndDate)}
                      showBlank={this.isDateRangeValid()}
                      // disabled={parentNode.key === 'week'}
                    />
                  </Grid>
                  <Grid item className={classes.MyPATCalendarUi}>
                    <MyPATCalendar
                      onChange={this.handleEndDate}
                      date={milestoneEndDate}
                      // minDate={this.getMinDate(minDate)}
                      // maxDate={this.getMaxDate(maxDate)}
                      minDate={
                        parentNode.key === 'week'
                          ? getEndDateOfLastWeek(parentNode, treeData)
                          : getMinDateForEnd(milestoneStartDate)
                      }
                      maxDate={parentNode.key === 'week' ? getNextPhaseStartDate(parentNode, treeData) : maxDate}
                      showBlank={this.isDateRangeValid()}
                    />
                  </Grid>
                  <Grid item>
                    <Checkbox
                      value='Is Revision'
                      color='primary'
                      onClick={(e: any) => this.handleIsRevision(e, minDate, maxDate)}
                    />
                    Is Revision?
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Button
                  style={{ marginRight: '8px' }}
                  variant='outlined'
                  size='small'
                  color='primary'
                  onClick={this.handleCancel}
                >
                  <strong>Cancel</strong>
                </Button>
                <Button
                  disabled={!this.isDateRangeValid()}
                  variant='contained'
                  size='small'
                  color='primary'
                  onClick={() => {
                    this.handleSave();
                  }}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </div>
        ) : (
          <> </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    editData: _.get(state, 'courseMangementData.contentManagementData.editData', {}),
    treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setEditData: contentManagementAction.setEditData,
      setTreeData: contentManagementAction.setTreeData,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(editMilestoneStyle)(AddCourseMileStone));
